import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from '@mui/material/ListItemText';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Mt4Select from "../../components/searchBar/Mt4Select";
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SelectFilter from '../../components/searchBar/SelectFilter';
import CountrySelect from '../../components/searchBar/CountrySelect';
import DateRangeFilter from '../../components/searchBar/DateRangeFilter';
import {
  ACCOUNT_TYPES,
  DEFAULT_MAU_DEPOSIT_WITHDRAW_STATE,
} from "../../constants/constants";
import * as types from '../../constants/actionTypes';
import AddCircle from '@mui/icons-material/AddCircle';
import PaymentMethod from '../DepositReport/PaymentMethod';
import PaymentStatus from '../DepositReport/PaymentStatus';
import PaymentChannel from '../DepositReport/PaymentChannel';
import UserLevelFilter from "../../components/searchBar/UserLevelFilter";
import { makeStyles } from "@mui/styles";
import theme from '../../constants/theme';


const useStyles = makeStyles(() => ({
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    fontStyle: "italic",
  },
  selectControl: {
    width: 250,
  },
  selectedFilters: {
    display: "flex",
    flexWrap: "wrap",
  },
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const MauDepositWithdrawFilter = () => {
  const classes = useStyles();
  const { filters, levelId, showAll, userAndLevelName, mt4AccountList, seletedMt4AccountList, countryList, selectedCountries, mauDepositWithdrawState } = useSelector((state) => state.report);
  const dispatch = useDispatch();
  const setFilters = (filters) => dispatch({ type: types.SET_FILTERS, filters });
  const selectCountries = (val) => dispatch({ type: types.SET_SELECTED_COUNTRIES, value: val });
  const setMauDepositWithdrawState = (val) => dispatch({ type: types.SET_MAU_DEPOSIT_WITHDRAW_STATE, value: val });
  const setSelectedMt4Accounts = (val) => dispatch({ type: types.SET_SELECTED_MT4_ACCOUNT_LIST, value: val });
  const setSelectedContinents = (val) => dispatch({ type: types.SET_CONTINENTS_LIST, value: val });
  const setUserAndLevelName = (val) => dispatch({ type: types.SET_USER_AND_LEVEL_NAME, value: val });
  const setLevelId = (val) => dispatch({ type: types.SET_LEVEL_ID, value: val });
  const setShowAll = (val) => dispatch({ type: types.SET_SHOW_ALL, value: val });

  const filterList = [
    {
      label: "Date Range",
      value: "dateRange",
      keys: ["fromDate", "toDate"],
      required: true,
    },
    {
      label: "User & Level",
      value: "userAndLeve",
      keys: ["userAndLeve"],
      required: true,
    },
    {
      label: "Account Type",
      value: "accountType",
      keys: ["accountType"],
      required: true,
    },
    {
      label: "Country",
      value: "country",
      keys: ["countryCodes"],
      show: true,
    },
    {
      label: "MT4 Account",
      value: "mt4Account",
      keys: ["mt4Account"],
      show: true,
    },
    {
      label: "Payment Status",
      value: "paymentStatus",
      keys: ["paymentStatus"],
      show: true,
    },
    {
      label: "Payment Method",
      value: "paymentMethod",
      keys: ["paymentMethod"],
      show: true,
    },
    {
      label: "Payment Channel",
      value: "paymentChannel",
      keys: ["paymentChannel"],
      show: true,
    },
  ];

  const [selectedFilters, setSelectedFilters] = useState(
    filterList.filter((r) => r.required || r.show).map((r) => r.value)
  );

  const toggleFilter = (val) => {
    setSelectedFilters(val);
    // reset filter value if it's not selected
    const filterKeys = filterList
      .filter((r) => val.includes(r.value))
      .flatMap((r) => r.keys);
    const newFilters = { ...mauDepositWithdrawState};
    Object.keys(mauDepositWithdrawState).forEach((r) => {
      if (!(filterKeys.includes(r) || ['withdraw','deposit'].includes(r))) {
        newFilters[r] = DEFAULT_MAU_DEPOSIT_WITHDRAW_STATE[r];
      }
    });
    setMauDepositWithdrawState(newFilters)
    // reset countryCodes
    if (!filterKeys.includes('countryCodes')) {
      selectCountries([]);
      setSelectedContinents([]);
    }
    if (!filterKeys.includes('mt4Account')) {
      setSelectedMt4Accounts([]);
    }
  };

  const isVisible = (id) => {
    return selectedFilters.includes(id);
  };

  const selectedFilterCount = selectedFilters.length;

  const onClickWithdraw = e => {
    setMauDepositWithdrawState({ ...mauDepositWithdrawState, 'withdraw': !mauDepositWithdrawState['withdraw']});
  };
  const onClickDeposit = e => {
    setMauDepositWithdrawState({ ...mauDepositWithdrawState, 'deposit': !mauDepositWithdrawState['deposit']});
  };

  useEffect(() => {
    const {
      fromDate,
      toDate,
      accountType,
      deposit,
      withdraw,
      depositDataType,
      depositPaymentStatus,
      depositPaymentMethod,
      depositPaymentChannel,
      withdrawDataType,
      withdrawPaymentStatus,
      withdrawPaymentMethod,
      withdrawPaymentChannel,
    } = mauDepositWithdrawState;

    const codes = selectedCountries.map(r => r.value).join(',');
    setFilters({
      fromDate,
      toDate,
      accountType,
      deposit,
      withdraw,
      depositDataType,
      depositPaymentStatus,
      depositPaymentMethod,
      depositPaymentChannel,
      withdrawDataType,
      withdrawPaymentStatus,
      withdrawPaymentMethod,
      withdrawPaymentChannel,
      countryCodes: codes || undefined,
      levelId,
      showAll
    });
  }, [mauDepositWithdrawState, selectedCountries, levelId, showAll]);

  return (
    <>
      <div className={classes.formControl}>
        <InputLabel id="filter-mutiple-checkbox-label">
          <AddCircle color="primary" />
        </InputLabel>
        <Select
          className={classes.selectControl}
          labelId="filter-mutiple-checkbox-label"
          id="filter-mutiple-checkbox"
          multiple
          value={selectedFilters}
          onChange={(e) => toggleFilter(e.target.value)}
          input={<Input />}
          renderValue={(selected) => `${selectedFilterCount} filters selected`}
        >
          {filterList.map((option) => (
            <MenuItem
              key={option.value}
              disabled={option.required}
              value={option.value}
            >
              <Checkbox
                color="primary"
                checked={selectedFilters.includes(option.value)}
              />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </div>
      <DateRangeFilter
        selectedFromDate={mauDepositWithdrawState.fromDate}
        setSelectedFromDate={(val) => setMauDepositWithdrawState({ ...mauDepositWithdrawState, fromDate: val })}
        selectedToDate={mauDepositWithdrawState.toDate}
        setSelectedToDate={(val) => setMauDepositWithdrawState({ ...mauDepositWithdrawState, toDate: val })}
      />

      {isVisible("userAndLeve") && (
          <UserLevelFilter 
            levelId={levelId}
            setLevelId={setLevelId}
            showAll={showAll}
            setShowAll={setShowAll}
            userAndLevelName={userAndLevelName}
            setUserAndLevelName={setUserAndLevelName}
          />
        )}

      <SelectFilter
        size="small"
        select
        variant="outlined"
        label="Account Type"
        InputLabelProps={{
          shrink: true,
        }}
        SelectProps={{
          value: mauDepositWithdrawState.accountType || "",
          onChange: (e) =>
            setMauDepositWithdrawState({ ...mauDepositWithdrawState, accountType: e.target.value || "" }),
          displayEmpty: true,
        }}
      >
        <MenuItem value="">
          <em>All Account Types</em>
        </MenuItem>
        <MenuItem value={ACCOUNT_TYPES.TRADING_ACCOUNT}>
          Trading Account
        </MenuItem>
        <MenuItem value={ACCOUNT_TYPES.REBATE_ACCOUNT}>Rebate Account</MenuItem>
      </SelectFilter>

      {isVisible("mt4Account") && (
      <Mt4Select
          data={mt4AccountList}
          onChange={(val) => setSelectedMt4Accounts(val)}
          value={seletedMt4AccountList}
      />
      )}

      {isVisible("country") && (
        <CountrySelect
           data={countryList}
           onChange={(val) => selectCountries(val)}
           value={selectedCountries}
         />
      )}
    <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
      <ListItem button onClick={onClickDeposit}>
        <ListItemIcon>
          <Checkbox className={classes.checkbox} checked={mauDepositWithdrawState.deposit} color="primary"/>
        </ListItemIcon>
        <ListItemText primary="Deposit" />
        {mauDepositWithdrawState.deposit ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={mauDepositWithdrawState.deposit} timeout="auto" unmountOnExit>
      {isVisible('paymentStatus') && (<PaymentStatus
        id="multiple-deposit-status-select"
        value={mauDepositWithdrawState.depositPaymentStatus}
        dataType={mauDepositWithdrawState.depositDataType}
        onChange={(val) => setMauDepositWithdrawState({ ...mauDepositWithdrawState, depositPaymentStatus: val})}
      />)}
      {isVisible('paymentMethod') && (<PaymentMethod
          value={mauDepositWithdrawState.depositPaymentMethod}
          dataType={mauDepositWithdrawState.depositDataType}
          onChange={(val) => setMauDepositWithdrawState({ ...mauDepositWithdrawState, depositPaymentMethod: val, depositPaymentChannel: ''})}
      />)}
      {isVisible('paymentChannel') && (<PaymentChannel
          value={mauDepositWithdrawState.depositPaymentChannel}
          dataType={mauDepositWithdrawState.depositDataType}
          paymentMethod={mauDepositWithdrawState.depositPaymentMethod}
          onChange={(val) => setMauDepositWithdrawState({ ...mauDepositWithdrawState, depositPaymentChannel: val})}
      />)}
      </Collapse>
      <ListItem button onClick={onClickWithdraw}>
        <ListItemIcon>
          <Checkbox className={classes.checkbox} checked={mauDepositWithdrawState.withdraw} color="primary"/>
        </ListItemIcon>
        <ListItemText primary="Withdraw" />
        {mauDepositWithdrawState.withdraw ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={mauDepositWithdrawState.withdraw} timeout="auto" unmountOnExit>
        {isVisible('paymentStatus') && (<PaymentStatus
            id="multiple-withdraw-status-select"
            value={mauDepositWithdrawState.withdrawPaymentStatus}
            dataType={mauDepositWithdrawState.withdrawDataType}
            onChange={(val) => {
              setMauDepositWithdrawState({ ...mauDepositWithdrawState, withdrawPaymentStatus: val});
            }}
        />)}
        {isVisible('paymentMethod') && (<PaymentMethod
            value={mauDepositWithdrawState.withdrawPaymentMethod}
            dataType={mauDepositWithdrawState.withdrawDataType}
            onChange={(val) => setMauDepositWithdrawState({ ...mauDepositWithdrawState, withdrawPaymentMethod: val, withdrawPaymentChannel: ''})}
        />)}
        {isVisible('paymentChannel') && (<PaymentChannel
            value={mauDepositWithdrawState.withdrawPaymentChannel}
            dataType={mauDepositWithdrawState.withdrawDataType}
            paymentMethod={mauDepositWithdrawState.withdrawPaymentMethod}
            onChange={(val) => {
              setMauDepositWithdrawState({ ...mauDepositWithdrawState, withdrawPaymentChannel: val})
            }}
        />)}
      </Collapse>
    </List>
    {/* <pre>{JSON.stringify(mauDepositWithdrawState, null, 2)}</pre> */}
    </>
  );
};

export default MauDepositWithdrawFilter;
